import { useMemo } from 'react';

type Step = string | number | symbol;

const useProgress = <T extends Step>(currentStep: T, steps: readonly T[]) => {
  return useMemo(() => {
    const currentStepIndex = steps.indexOf(currentStep);

    if (currentStepIndex === -1) {
      console.warn(
        `Current step "${currentStep as string}" not found in steps array.`
      );
      return 0;
    }

    return Math.round((currentStepIndex / (steps.length - 1)) * 100);
  }, [currentStep, steps]);
};

export { useProgress };
